import { render, staticRenderFns } from "./StudentTransfer.vue?vue&type=template&id=6dc06090&scoped=true"
import script from "./StudentTransfer.vue?vue&type=script&lang=js"
export * from "./StudentTransfer.vue?vue&type=script&lang=js"
import style0 from "./StudentTransfer.vue?vue&type=style&index=0&id=6dc06090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc06090",
  null
  
)

export default component.exports